//import React from 'react';

class AnalyticsAuth extends wp.element.Component {

  constructor(props) {
    super(props);
    this.state = { 
      connected: false,
      trackingId: meowAnalytics.tracking_id,
      expiresAt: meowAnalytics.expires_at,
      accessToken: meowAnalytics.access_token,
    };
  }

  componentDidMount() {
    meowAnalytics.refreshToken = () => this.refreshToken();
    gapi.analytics.ready(() => this.googleAuthorize());
  }

  async googleAuthorize() {
    this.props.onSigningIn?.();
    if (this.state.accessToken) {
      gapi.analytics.auth.authorize({ serverAuth: { access_token: this.state.accessToken } });
      return await this.findViewId();
    }
    return false;
  }

  async getAccounts() {
    return new Promise((resolve, reject) => {
      const request = gapi.client.analytics.management.accounts.list();
      request.execute(results => {
        if (results.error) {
          reject(results.error);
          return;
        }
        const username = results.username;
        const accounts = results.items.map(x => { return { accountId: x.id, accountName: x.name } });
        if ( meowAnalytics.debug_mode ) {
          console.log('Meow Analytics: Account loaded.', username, accounts);
        }
        resolve({ username, accounts });
      });
    });
  };
  
  async getWebProperties(accountId) {
    return new Promise((resolve, reject) => {
      const request = gapi.client.analytics.management.webproperties.list({ 'accountId': accountId });
      request.execute(results => {
        if (results.error) {
          reject(results.error);
          return;
        }
        const properties = results.items.map(x => { return { webPropertyId: x.id, accountId: x.accountId, name: x.name } });
        resolve(properties);
      });
    });
  };
  
  // Profiles
  async getViews(accountId, webPropertyId) {
    return new Promise((resolve, reject) => {
      const request = gapi.client.analytics.management.profiles.list({ 'accountId': accountId, 'webPropertyId': webPropertyId });
      request.execute(results => {
        if (results.error) {
          reject(results.error);
          return;
        }
        const views = results.items.map(x => { return { viewId: x.id, accountId, webPropertyId } });
        resolve(views);
      });
    });
  };

  // The Tracking Id doesn't work in the API, we absolutely need the View ID instead.
  // After connection, this will look for the View ID that corresponds to the Tracking Id.
  async findViewId() {
    const localStorageKey = 'meow-analytics-' + this.state.trackingId;
    let mgaStore = localStorage.getItem( localStorageKey );
    try { mgaStore = JSON.parse( mgaStore ); } catch { mgaStore = null; }

    if (!mgaStore) {
      const { username, accounts } = await this.getAccounts();
      const properties = [];
      for ( let account of accounts )
        properties.push(...await this.getWebProperties(account.accountId));
      const property = properties.find(x => x.webPropertyId === this.state.trackingId);
      if (!property) {
        alert('Could not found the Tracking Id ' + this.state.trackingId + ' under this account.');
        console.log('Tracking Id', this.state.trackingId, 'Properties', properties);
        return false;
      }
      const views = await this.getViews( property.accountId, property.webPropertyId );
      if ( meowAnalytics.debug_mode ) {
        console.log('Meow Analytics: Found ViewID.', views[0] );
      }
      mgaStore = { username, viewId: views[0].viewId };
      localStorage.setItem( localStorageKey, JSON.stringify( mgaStore ) );
    }
    if ( meowAnalytics.debug_mode ) {
      console.log('Meow Analytics: Ready.', this.state);
    }
    this.setState({ connected: true });
    this.props.onSignIn( mgaStore.viewId );
    this.checkIfTokenExpires();
    return true;
  }

  async refreshToken() {
    let freshSettings = await jQuery.post(ajaxurl, { action: 'mga_refresh_token' });
    freshSettings = JSON.parse(freshSettings);
    meowAnalytics.expires_at = freshSettings.expires_at;
    meowAnalytics.access_token = freshSettings.access_token;
    this.setState({
      trackingId: freshSettings.tracking_id,
      expiresAt: freshSettings.expires_at,
      accessToken: freshSettings.access_token
    });
    gapi.client.setToken({ access_token: freshSettings.access_token });
    const results = await this.getAccounts();
    if (!results.username) {
      return false;
    }
    if ( meowAnalytics.debug_mode ) {
      console.log('Meow Analytics: Token updated.', this.state);
    }
    return true;
  }

  async checkIfTokenExpires() {
    if (!this.state.connected) {
      return;
    }
    const now = (new Date()).getTime() / 1000;
    const left = this.state.expiresAt - now;
    if ( left < ( 60 * 5 ) ) {
      let success = await this.refreshToken();
      if (!success) {
        console.log('Meow Analytics: Failed to refresh, will not retry.');
        return;
      }
    }
    setTimeout(() => this.checkIfTokenExpires(), 30 * 1000);
  }

  render() {
    return (<div></div>);
  }
}

export default AnalyticsAuth;